import React, { useState } from "react";
import "../../Assets/CSS/EditEployee.css";
import { Icon } from "@iconify/react";

const EditModel = ({ employee, onClose, onSave }) => {
  const [formData, setFormData] = useState({ ...employee });
  console.log("=================", formData, "form")
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name.includes("Leave") ? Number(value) : value,
    }));
  };

  // const handleSubmit = (e) => {
  //   console.log(formData, "edit data");
  //   e.preventDefault();
  //   onSave(formData); // Pass updated data to parent component
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // call parent save function
      await onSave(formData);

      // you may want to close modal here if successful
      // onClose();
    } catch (error) {
      console.error("Error updating employee:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content-edit">
        <div className="modal-header">
          <h5>Edit Employee</h5>
          <button onClick={onClose} className="close-btn">
            <Icon icon="iconoir:cancel" width="18" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          {/* Personal Info */}
          <div className="form-row">
            <div className="form-group">
              <label>First Name</label>
              <input
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Middle Name</label>
              <input
                name="middleName"
                value={formData.middleName}
                onChange={handleChange}
                required
              />
            </div>

          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Last Name</label>
              <input
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Email (Personal)</label>
              <input
                name="personalEmail"
                type="email"
                value={formData.personalEmail}
                onChange={handleChange}
                required
              />
            </div>

          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Date of Birth</label>
              <input
                name="dateOfBirth"
                type="date"
                value={formData.dateOfBirth}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Mobile Number</label>
              <input
                name="mobileNumber"
                type="tel"
                value={formData.mobileNumber}
                onChange={handleChange}
                required
                maxLength={10}
              />
            </div>

          </div>
          <div className="form-row">
            <div className="form-group">
              {/* Job Info */}
              <label>Department</label>
              <input
                name="departmentName"
                value={formData.departmentName}
                onChange={handleChange}
                required
                readOnly
              />
            </div>
            <div className="form-group">
              <label>Designation</label>
              <input
                name="designation"
                value={formData.designation}
                onChange={handleChange}
                required
              />
            </div>

          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Manager ID</label>
              <input
                name="managerId"
                value={formData.managerId}
                onChange={handleChange}
                required
                readOnly
              />
            </div>
            <div className="form-group">
              <label>Company Email</label>
              <input
                name="officeEmail"
                type="email"
                value={formData.officeEmail}
                onChange={handleChange}
                required
                readOnly
              />
            </div>

          </div>
          <div className="form-row">
            <div className="form-group">
              {/* Leave Info */}
              <label>Sick Leave</label>
              <input
                name="totalAllocatedSickLeave"
                type="number"
                value={formData.totalAllocatedSickLeave}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Casual Leave</label>
              <input
                name="totalAllocatedCasualLeave"
                type="number"
                value={formData.totalAllocatedCasualLeave}
                onChange={handleChange}
                required
              />
            </div>

          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Earned Leave</label>
              <input
                name="totalAllocatedEarnedLeave"
                type="number"
                value={formData.totalAllocatedEarnedLeave}
                onChange={handleChange}
                required
              />
            </div>

          </div>

          <div className="form-actions">
            <button type="button" className="cancel-btn" onClick={onClose}>
              Cancel
            </button>
            {/* <button type="submit" className="save-btn">
              Update
            </button> */}
            <button type="submit" className="save-btn" disabled={loading}>
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Updating...
                </>
              ) : (
                "Update"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditModel;
